import { useState, useEffect } from 'react';
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import Seo from '../components/seo'
import Hero from '../components/Hero'

import Benefits from '../components/Benefits';
import ReferenceSearch from '../components/ReferenceSearch';
import TextImage from '../components/TextImages/TextImage';
import Text from '../components/TextImages/Text';
import DoubleImageText from '../components/TextImages/DoubleImageText';
import TextImageLeft from '../components/TextImages/TextImageLeft';
import Contact from '../components/Contact';
import Steps from '../components/Steps';
import Locations from '../components/Locations';
import MostPopularProducts from '../components/MostPopularProducts';
import ProductsTeaser from '../components/ProductsTeaser';
import MagazineTeaser from '../components/MagazineTeaser';
import RecentlyAddedProducts from '../components/RecentlyAddedProducts';
import { TrustPilotCarousel, TrustPilotMiniCarousel } from '../components/TrustPilot/Trustbox';
import { OpacityWrapper } from '../components/Atoms/Animations';
import { ABOUT_US_ROUTE, BUYING_CATALOG_ROUTE, CONTACT_ROUTE, SELLING_INDEX_ROUTE } from '../utils/routes/const';

const HomeSellComponents = ({ data }: { data: any }) => (
  <OpacityWrapper>
    <Benefits />
    <ReferenceSearch />
    <TrustPilotCarousel />
    <TextImage
      title='textImage.title'
      subtitle='textImage.subtitle'
      image={data.textImage}
      url={ABOUT_US_ROUTE}
      description='textImage.description'
    />
    <Text />
    <DoubleImageText
      textWrapperClass="lg:pt-8 xl:pt-24"
      url={ABOUT_US_ROUTE}
    />
    <Contact
      wrapperClass='xl:w-7/12 xl:ml-auto flex flex-col md:flex-row bg-top bg-repeat-x py-12'
      url={SELLING_INDEX_ROUTE}
    />
    <Steps />
    <ProductsTeaser />
    <Contact url={SELLING_INDEX_ROUTE} />
    <TextImage
      title='textImageRight.subtitle'
      subtitle='textImageRight.title'
      image={data.textImageRight}
      url={ABOUT_US_ROUTE}
      cta='textImageRight.cta'
      imgClass='flex-shrink-0 flex xl:w-1/2 lg:mr-16 xl:mr-0'
      isTextPrimary={false}
      isImageRight={false}
      withTrustLogo={false} />
    <Locations />
    <TrustPilotCarousel />
    <MagazineTeaser />
    <TrustPilotMiniCarousel />
  </OpacityWrapper>
)

const HomeBuyComponents = ({ data }: { data: any }) => (
  <OpacityWrapper>
    <RecentlyAddedProducts />
    <Contact
      title='buy.contact.0.title'
      cta='buy.contact.cta'
      url={BUYING_CATALOG_ROUTE()}
      hasContactPerson={false}
    />
    <Benefits
      type="buy"
    />
    <TrustPilotCarousel />
    <ProductsTeaser />
    <TextImageLeft
      description='buy.textimage.0.description'
      subtitle='buy.textimage.0.subtitle'
      title='buy.textimage.0.title'
      cta='buy.textimage.0.cta'
      image={data.textImage}
      url={CONTACT_ROUTE}
      imgWrapperClass='mt-8 lg:mt-0 flex-shrink-0 flex lg:w-5/12'
      textWrapperClass='lg:w-4/12 pr-16'
      withTrustLogo
    />
    <MostPopularProducts />
    <Contact
      title='buy.contact.1.title'
      cta='buy.contact.cta'
      url={BUYING_CATALOG_ROUTE()}
    />
    <TextImage
      title='textImageRight.subtitle'
      subtitle='textImageRight.title'
      image={data.textImageRight}
      url={ABOUT_US_ROUTE}
      cta='textImageRight.cta'
      isTextPrimary={false}
      isImageRight={false}
      withTrustLogo={false}
    />
    <Locations />
    <TrustPilotCarousel />
    <MagazineTeaser />
  </OpacityWrapper>
)

const getInitialComponents = () => {
  if (typeof window === 'undefined') return '';

  if (window.location.hash !== '') {
    return window.location.hash.replace('#', '');
  }

  return '';
}

const IndexPage = ({ data }: { data: any }) => {
  const [type, setType] = useState(getInitialComponents());

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('hashchange', () => {
      setType(window.location.hash.replace('#', ''));
    });
  }, [])


  return (
    <Layout bgColor='bg-white' footerColor={type === '' ? 'bg-white' : 'bg-gray'}>
      <Seo title="Home" />
      <Hero />
      <div className={`${type === 'sell' ? 'block' : 'hidden'}`} id="sell">
        <HomeSellComponents data={data} />
      </div>
      <div className={`${type === 'buy' ? 'block' : 'hidden'}`} id="buy">
        <HomeBuyComponents data={data} />
      </div>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    textImage: file(base: {eq: "textimage.jpg"}) {
      base
      childImageSharp {
        gatsbyImageData(
          width: 559
          avifOptions: {lossless: true}
        )
      }
  	}
    textImageRight: file(base: {eq: "textimageRight.jpg"}) {
      base
      childImageSharp {
        gatsbyImageData(
          placeholder: DOMINANT_COLOR
          width: 446
          avifOptions: {lossless: true}
        )
      }
    }
  }
`
